import {
  getFilterListRegions,
  getSensorTowerTagFilterList,
  fetchRegionsCountriesOfPCGameDetailsStoreRankPlus,
} from '@/pages/intelligence/services/filter';
import { getOptions } from '@intelligence/components/GenreSelectMiddleware/Supports/services';
import { getFilterSaveList } from '@/pages/intelligence/services/common';
import { fetchGenreSourcesOptionsAll } from '@intelligence/components/GenreSelectMiddleware/services';
import { getQueryDefinition } from '@intelligence/services/common';
import { formatGenreSourcesOptions } from '@intelligence/v3/utils/genre';
// import { getCondLoadingObj } from '@intelligence/utils/filterUtils';

// 整合全局公共配置对象loading状态
export const getCondLoadingObj = (data: any = {}, booleanValue: boolean) => {
  const loading = Object.keys(data).reduce(
    (acc, key) => ({
      ...acc,
      [key]: booleanValue,
    }),
    {},
  );
  return loading;
};

const GLOBAL_COUNTRY: IRegionCountryEntity = {
  intel_region_abbre: 'global',
  intel_region_name_en: 'Global',
  intel_region_name_cn: '全球',
  country_name_abbre: 'global',
  country_name_en: 'Global',
  country_name_cn: '全球',
};

const GLOBAL_WO_CHINA_COUNTRY: IRegionCountryEntity = {
  intel_region_abbre: 'global_wo_china',
  intel_region_name_en: 'Global except China mainland',
  intel_region_name_cn: '全球（不包括中国大陆）',
  country_name_abbre: 'global_wo_china',
  country_name_en: 'Global except China mainland',
  country_name_cn: '全球（不包括中国大陆）',
};

const BASIC_COUNTRY_MAP: IRecord<IRegionCountryEntity> = {
  global: GLOBAL_COUNTRY,
  global_wo_china: GLOBAL_WO_CHINA_COUNTRY,
};

const addCountryAndRegionMap = (map?: any): any => {
  if (!map) return {};
  if (!Reflect.has(map, 'countryMap')) return map;

  const countries = Reflect.get(map, 'countryMap') || [];
  const regionMap: IRecord<IRegionCountryEntity> = { ...BASIC_COUNTRY_MAP };
  const countryMap: IRecord<IRegionCountryEntity> = { ...BASIC_COUNTRY_MAP };

  for (const country of countries) {
    const regionCode = country?.intel_region_abbre?.toLowerCase() || '';
    const countryCode = country?.country_name_abbre?.toLowerCase() || '';
    if (!!regionCode) {
      regionMap[regionCode] = country;
    }
    if (!!countryCode) {
      countryMap[countryCode] = country;
    }
  }

  return {
    ...map,
    regionMapNew: regionMap,
    countryMapNew: countryMap,
  };
};

export const FILTER_NAMESPACE = 'intelligence_filter';

export const DEFAULT_FILTER_SAVE_LIST_BY_TYPE_ITEM = {
  loading: true,
  data: null,
};

const MonetizationModel = {
  namespace: FILTER_NAMESPACE,
  state: {
    filterSaveList: {
      loading: false,
      data: null,
    },
    filterSaveListKpiTrends: {
      loading: false,
      data: null,
    },
    filterSaveListByType: {},
    commonMarketFilter: {
      loading: false,
      data: null,
    },
    rpdMarketFilter: {
      loading: false,
      data: null,
    },
    retentionMarketFilter: {
      loading: false,
      data: null,
    },
    mobilePheatMarketFilter: {
      loading: false,
      data: null,
    },
    topCompaniesMarketFilter: {
      loading: false,
      data: null,
    },
    pcGamesDetailsStoreRankMarketFilter: {
      loading: false,
      data: null,
    },
    metricsTableMarketFilter: {
      loading: false,
      data: null,
    },
    digitalRevenueMarketFilter: {
      loading: false,
      data: null,
    },
    // 品类接口数据
    commonGrenreFilter: {
      loading: false,
      data: null,
    },
    commonCondFilter: {
      loading: false,
      // 跟loading一样的用法，只是默认值为true，由于loading被个场景复用了，所以新增了一个默认值为true的loading
      loadingStd: true,
      data: {},
    },
    senTowerTagFilter: {
      loading: false,
      data: null,
    },
    gsdMarketFilter: {
      loading: false,
      data: null,
    },
  },

  effects: {
    // 获取筛选器保存列表
    *getFilterSaveList({ payload }, { put }) {
      try {
        put({ type: 'saveFilterSaveList', payload: { loading: true, data: null } });
        // TODO写类型
        const result = yield getFilterSaveList(payload);
        yield put({
          type: 'saveFilterSaveList',
          payload: { loading: false, data: result?.data || [] },
        });
        return result;
      } catch (e) {
        yield put({
          type: 'saveFilterSaveList',
          payload: { loading: false, data: null },
        });
      }
    },
    // 获取筛选器Trends保存列表
    *getFilterSaveListTrends({ payload }, { put }) {
      try {
        put({ type: 'saveFilterSaveListKpiTrends', payload: { loading: true, data: null } });
        // TODO写类型
        const result = yield getFilterSaveList({ type: 'usersave-combine-detail-kpitrends' });
        yield put({
          type: 'saveFilterSaveListKpiTrends',
          payload: { loading: false, data: result?.data || [] },
        });
        return result;
      } catch (e) {
        yield put({
          type: 'saveFilterSaveListKpiTrends',
          payload: { loading: false, data: null },
        });
      }
    },
    *getFilterSaveListByType({ payload }, { put }) {
      const filterSaveType = payload?.type || '';
      if (!filterSaveType) {
        return null;
      }

      try {
        yield put({
          type: 'saveFilterSaveListByType',
          payload: {
            [filterSaveType]: { ...DEFAULT_FILTER_SAVE_LIST_BY_TYPE_ITEM },
          },
        });

        const result = yield getFilterSaveList({ type: filterSaveType });

        yield put({
          type: 'saveFilterSaveListByType',
          payload: {
            [filterSaveType]: { loading: false, data: result?.data || [] },
          },
        });

        return result;
      } catch (e) {
        yield put({
          type: 'saveFilterSaveListByType',
          payload: {
            [filterSaveType]: { loading: false, data: null },
          },
        });

        return null;
      }
    },
    // 获取公共品类筛选器
    *getCommonGenreFilter({ payload }, { put }) {
      try {
        put({ type: 'saveCommonGrenreFilter', payload: { loading: true, data: null } });
        // TODO写类型
        const result = yield fetchGenreSourcesOptionsAll(payload?.entityType);
        yield put({
          type: 'saveCommonGrenreFilter',
          payload: { loading: false, data: result?.data },
        });
        return result?.data;
      } catch (e) {
        yield put({
          type: 'saveCommonGrenreFilter',
          payload: { loading: false, data: null },
        });
      }
    },
    // 获取公共筛选器通用配置
    *getCommonCondFilter({ payload }, { put }) {
      try {
        yield put({ type: 'saveCommonCondFilter', payload: { loading: true, loadingStd: true, data: null } });
        // TODO写类型
        const result = yield getQueryDefinition(payload?.paramsValue);
        const resDatas = result?.data || {};
        const resDatasValue = {
          ...payload?.condDatas,
          ...addCountryAndRegionMap(resDatas),
          genreOptionsMap: formatGenreSourcesOptions(resDatas?.genreMap),
        };
        yield put({
          type: 'saveCommonCondFilter',
          payload: {
            loading: false,
            loadingStd: false,
            data: resDatasValue,
          },
        });
        return resDatasValue;
      } catch (e) {
        yield put({
          type: 'saveCommonCondFilter',
          payload: { loading: false, loadingStd: false, data: {} },
        });
      }
    },
    // 获取公共国家筛选器
    *getCommonMarketFilter({ payload }, { put }) {
      try {
        put({ type: 'saveCommonMarketFilter', payload: { loading: true, data: null } });
        // TODO写类型
        const result = yield getFilterListRegions(payload);
        yield put({ type: 'saveCommonMarketFilter', payload: { loading: false, data: result } });
        return result;
      } catch (e) {
        yield put({
          type: 'saveCommonMarketFilter',
          payload: { loading: false, data: null },
        });
      }
    },
    // 获取RPD类型国家筛选器
    *getRpdMarketFilter({ payload }, { put }) {
      try {
        put({ type: 'saveRpdMarketFilter', payload: { loading: true, data: null } });
        // TODO写类型
        const result = yield getFilterListRegions(payload);
        yield put({ type: 'saveRpdMarketFilter', payload: { loading: false, data: result } });
        return result;
      } catch (e) {
        yield put({
          type: 'saveRpdMarketFilter',
          payload: { loading: false, data: null },
        });
      }
    },
    // 获取Retention类型国家筛选器
    *getRetentionMarketFilter({ payload }, { put }) {
      try {
        put({ type: 'saveRetentionMarketFilter', payload: { loading: true, data: null } });
        // TODO写类型
        const result = yield getFilterListRegions(payload);
        yield put({ type: 'saveRetentionMarketFilter', payload: { loading: false, data: result } });
        return result;
      } catch (e) {
        yield put({
          type: 'saveRetentionMarketFilter',
          payload: { loading: false, data: null },
        });
      }
    },
    // 获取Retention类型国家筛选器
    *getMobilePheatMarketFilter({ payload }, { put }) {
      try {
        put({ type: 'saveMobilePheatMarketFilter', payload: { loading: true, data: null } });
        // TODO写类型
        const result = yield getFilterListRegions(payload);
        yield put({
          type: 'saveMobilePheatMarketFilter',
          payload: { loading: false, data: result },
        });
        return result;
      } catch (e) {
        yield put({
          type: 'saveMobilePheatMarketFilter',
          payload: { loading: false, data: null },
        });
      }
    },
    // 获取公司榜单国家筛选器
    *getTopCompaniesMarketFilter({ payload }: any, { put }: any) {
      try {
        put({ type: 'saveTopCompaniesMarketFilter', payload: { loading: true, data: null } });
        const { type, formatter } = payload ?? {};
        // TODO写类型
        let result: any = yield getOptions(type);
        if (typeof formatter === 'function') {
          result = formatter(result);
        }
        yield put({
          type: 'saveTopCompaniesMarketFilter',
          payload: { loading: false, data: result },
        });
        return result;
      } catch (e) {
        yield put({
          type: 'saveTopCompaniesMarketFilter',
          payload: { loading: false, data: null },
        });
      }
    },
    // 获取PC游戏详情页store rank页签国家筛选器数据
    *getPCGamesDetailsStoreRankMarketFilter({ payload }: any, { put }: any) {
      try {
        put({
          type: 'savePCGamesDetailsStoreRankMarketFilter',
          payload: { loading: true, data: null },
        });
        const result: any = yield fetchRegionsCountriesOfPCGameDetailsStoreRankPlus(payload);
        yield put({
          type: 'savePCGamesDetailsStoreRankMarketFilter',
          payload: { loading: false, data: result },
        });
        return result;
      } catch (e) {
        yield put({
          type: 'savePCGamesDetailsStoreRankMarketFilter',
          payload: { loading: false, data: null },
        });
      }
    },
    //
    *getGSDMarketFilter({ payload }: any, { put }: any) {
      try {
        put({ type: 'saveGSDMarketFilter', payload: { loading: true, data: null } });
        // TODO写类型
        const result = yield getFilterListRegions(payload);
        yield put({ type: 'saveGSDMarketFilter', payload: { loading: false, data: result } });
        return result;
      } catch (e) {
        yield put({
          type: 'saveGSDMarketFilter',
          payload: { loading: false, data: null },
        });
      }
    },
    // 获取Retention类型国家筛选器
    *getMetricsTableMarketFilter({ payload }, { put }) {
      try {
        put({ type: 'saveMetricsTableMarketFilter', payload: { loading: true, data: null } });
        // TODO写类型
        const result = yield getFilterListRegions(payload);
        yield put({
          type: 'saveMetricsTableMarketFilter',
          payload: { loading: false, data: result },
        });
        return result;
      } catch (e) {
        yield put({
          type: 'saveMetricsTableMarketFilter',
          payload: { loading: false, data: null },
        });
      }
    },
    // 获取Retention类型国家筛选器
    *getDigitalRevenueMarketFilter({ payload }, { put }) {
      try {
        put({ type: 'saveDigtalRevenueMarketFilter', payload: { loading: true, data: null } });
        // TODO写类型
        const result = yield getFilterListRegions(payload);
        yield put({
          type: 'saveDigtalRevenueMarketFilter',
          payload: { loading: false, data: result },
        });
        return result;
      } catch (e) {
        yield put({
          type: 'saveDigtalRevenueMarketFilter',
          payload: { loading: false, data: null },
        });
      }
    },
    *getSenTowerTagList({ payload }, { put }) {
      try {
        yield put({ type: 'saveSenTowerTagFilter', payload: { loading: false, data: null } });
        const result = yield getSensorTowerTagFilterList(payload);
        yield put({ type: 'saveSenTowerTagFilter', payload: { loading: false, data: result } });
        return result;
      } catch (e) {
        yield put({ type: 'saveSenTowerTagFilter', payload: { loading: false, data: null } });
      }
    },
  },
  reducers: {
    saveFilterSaveList(state: any, action: any) {
      return {
        ...state,
        filterSaveList: action.payload,
      };
    },
    saveFilterSaveListKpiTrends(state: any, action: any) {
      return {
        ...state,
        filterSaveListKpiTrends: action.payload,
      };
    },
    saveFilterSaveListByType(state: any, action: any) {
      return {
        ...state,
        filterSaveListByType: {
          ...state.filterSaveListByType,
          ...action.payload,
        },
      };
    },
    // 品类接口数据
    saveCommonGrenreFilter(state: any, action: any) {
      return {
        ...state,
        commonGrenreFilter: action.payload,
      };
    },
    // 通用筛选器配置接口数据
    saveCommonCondFilter(state: any, action: any) {
      return {
        ...state,
        commonCondFilter: action.payload,
      };
    },
    saveCommonMarketFilter(state: any, action: any) {
      return {
        ...state,
        commonMarketFilter: action.payload,
      };
    },
    saveRpdMarketFilter(state: any, action: any) {
      return {
        ...state,
        rpdMarketFilter: action.payload,
      };
    },
    saveRetentionMarketFilter(state: any, action: any) {
      return {
        ...state,
        retentionMarketFilter: action.payload,
      };
    },
    saveMobilePheatMarketFilter(state: any, action: any) {
      return {
        ...state,
        mobilePheatMarketFilter: action.payload,
      };
    },
    saveTopCompaniesMarketFilter(state: any, action: any) {
      return {
        ...state,
        topCompaniesMarketFilter: action?.payload,
      };
    },
    savePCGamesDetailsStoreRankMarketFilter(state: any, action: any) {
      return {
        ...state,
        pcGamesDetailsStoreRankMarketFilter: action?.payload,
      };
    },
    saveMetricsTableMarketFilter(state: any, action: any) {
      return {
        ...state,
        metricsTableMarketFilter: action.payload,
      };
    },
    saveDigtalRevenueMarketFilter(state: any, action: any) {
      return {
        ...state,
        digitalRevenueMarketFilter: action.payload,
      };
    },
    saveSenTowerTagFilter(state: any, action: any) {
      return {
        ...state,
        senTowerTagFilter: action.payload,
      };
    },
    saveGSDMarketFilter(state: any, action: any) {
      return {
        ...state,
        gsdMarketFilter: action.payload,
      };
    },
  },
};

export default MonetizationModel;
